import { IManualSubOrdersTableReport } from "../../../Interfaces/manualInterfaces";
import { getManualSubOrders } from "../../../Requests/manualRequests";
import { CommonTableUI } from "../../TableTemplate/common";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { SubOrdersTableAdditional } from "./SubOrdersTableAdditional";
import { memo } from "react";

interface ISubOrdersTableProps {
  manualStepOrderId: number;
}

const SubOrdersTable = memo(({ manualStepOrderId }: ISubOrdersTableProps) => {
  return (
    <TableTemplate<ISubOrdersTableProps, IManualSubOrdersTableReport>
      getDataTable={getManualSubOrders}
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          AdditionalBody={SubOrdersTableAdditional}
        />
      )}
      initialSearchParameters={{ manualStepOrderId }}
    />
  );
});

export default SubOrdersTable;
